import { Models } from '@rematch/core'
import { contentModel } from './models/content'
import { commonModel } from './models/common'

export interface RootModel extends Models<RootModel> {
  contentModel: typeof contentModel
  commonModel: typeof commonModel
}
export const models: RootModel = { contentModel, commonModel }
